
import { useAuthData } from "../context/loginContext/LoginContextProvider";

const RoleAccess = ({ children, modelName, component }) => {
  const { access } = useAuthData();
  const hasAccess = access.some(
    (data) =>
      data.module === modelName &&
      data.component === component &&
      data.can_access
  );
  return hasAccess ? <>{children}</> : null;
};

export default RoleAccess;
